// Hjelpefunksjoner for aktiviteter på Min side

import { dateFromYyyymmdd } from '../formatDate';

// Hent neste aktivitet brukeren er påmeldt (etter nåværende tidspunkt)
export const finnNesteAktivitet = aktiviteter => {
    const now = new Date();

    return (
        aktiviteter
            .filter(a => a.pameldt === 'J' && a.dato && a.fratid)
            .map(a => {
                const dato = dateFromYyyymmdd(a.dato);
                if (!dato) return null;

                const start = new Date(a.fratid);
                if (isNaN(start)) return null;

                start.setFullYear(dato.getFullYear(), dato.getMonth(), dato.getDate());

                return { ...a, _start: start };
            })
            .filter(a => a && a._start > now)
            .sort((a, b) => a._start - b._start)[0] ?? null
    );
};

// Sammenlign to arrays som sett (rekkefølge spiller ingen rolle)
export function arraysEqualAsSets(a = [], b = []) {
    const aa = [...a].sort((x, y) => x - y);
    const bb = [...b].sort((x, y) => x - y);

    return aa.length === bb.length && aa.every((val, index) => val === bb[index]);
}

// Gruppér aktiviteter per dato
export function hentAktiviteterPerDato(aktiviteter = []) {
    return aktiviteter.reduce((acc, aktivitet) => {
        if (!acc[aktivitet.dato]) acc[aktivitet.dato] = [];
        acc[aktivitet.dato].push(aktivitet);
        return acc;
    }, {});
}

// Finn første aktivitetsdato i et sett aktiviteter
export function finnForsteAktivitetsDato(aktiviteter = []) {
    const datoer = aktiviteter.map(a => Number(a.dato)).filter(Boolean);

    if (!datoer.length) return null;

    return Math.min(...datoer);
}

// CSS-klasse for aktivitetsbadge
export function getProgramTypeBadgeClass(typeNavn = '') {
    const normalized = String(typeNavn).trim().toUpperCase();

    if (normalized === 'TRENING') return 'program-type-badge--training';
    if (normalized === 'KONFERANSE') return 'program-type-badge--conference';
    if (normalized === 'FELLES') return 'program-type-badge--shared';

    return 'program-type-badge--default';
}
